<div class="device">
    <img src="/assets/sensocor-device.png" alt="Device" width="240" draggable="false" class="device__img">

    <div class="device__info flex-column-center">
        <h6 class="device__info-title">{{'devices.device-id' | translate}}:</h6>
        <strong class="device__info-id">{{device ? device?.serial : '-'}}</strong>
    </div>

    <div class="device__head flex-column-center">
        <span class="device__head-title">{{'devices.last-sample-update' | translate}}:</span>
        <time datetime="" class="device__head-value">{{ lastUpdate | date:'dd.MM.yy' }}</time>
    </div>
</div>